import { useState, useEffect } from 'react';
import { IconClose, Select, SelectSize } from '@ui/src';
import { CurrencySettingTypes } from './types';

import cn from './info.module.css';
import { ExternalVaultSettings } from '../../hoc/bank-and-psp/types';

const CurrencySettingItem = ({
  currencySetting,
  casp,
  currencies,
  externalVaultSettings,
  onUpdateExternalVaultSettings,
  currencyCASPRequiredErrors,
  setCurrencyCASPRequiredErrors,
  currencyCASPError,
  updateExternalSettingsIsLoading,
}: CurrencySettingTypes) => {
  const [caspId, setCaspId] = useState('');

  const onChange = (value: string) => {
    setCaspId(value);

    const nextExternalVaultSettings = { ...externalVaultSettings };

    const nextExternalCurrencies =
      nextExternalVaultSettings.externalAccountsAutoCreateCurrencies?.map(
        (item) => {
          const result = { ...item };

          if (item.id === currencySetting?.id) {
            result.caspId = value;
          }

          return result;
        },
      );

    nextExternalVaultSettings.externalAccountsAutoCreateCurrencies =
      nextExternalCurrencies;

    if (currencyCASPError && currencyCASPRequiredErrors) {
      setCurrencyCASPRequiredErrors(
        currencyCASPRequiredErrors?.filter(
          (item) => item.id !== currencySetting?.id,
        ),
      );
    }

    onUpdateExternalVaultSettings(
      nextExternalVaultSettings as ExternalVaultSettings,
    );
  };

  const onDelete = () => {
    const nextExternalVaultSettings = { ...externalVaultSettings };

    nextExternalVaultSettings.externalAccountsAutoCreateCurrencies =
      nextExternalVaultSettings.externalAccountsAutoCreateCurrencies?.filter(
        (item) => item.id !== currencySetting?.id,
      );

    if (currencyCASPError && currencyCASPRequiredErrors) {
      setCurrencyCASPRequiredErrors(
        currencyCASPRequiredErrors?.filter(
          (item) => item.id !== currencySetting?.id,
        ),
      );
    }

    onUpdateExternalVaultSettings(
      nextExternalVaultSettings as ExternalVaultSettings,
    );
  };

  useEffect(() => {
    if (currencySetting) {
      setCaspId(currencySetting.caspId as string);
    }
  }, [currencySetting]);

  return (
    <div className={cn.currencySettingItem}>
      <div className={cn.currencySettingItemName}>
        {
          currencies?.find((item) => item.id === currencySetting?.currencyId)
            ?.name
        }
      </div>
      <div className={cn.currencySettingItemSelect}>
        {!currencies?.find((item) => item.id === currencySetting?.currencyId)
          ?.code && (
          <Select
            name="caspId"
            value={caspId}
            list={casp}
            placeholder="Select CASP"
            size={SelectSize.SMALL}
            onChange={(e) => onChange(e.target.value as string)}
            error={currencyCASPError?.error}
            disabled={updateExternalSettingsIsLoading}
            fullWidth
          />
        )}
      </div>
      <button
        type="button"
        className={cn.deleteCurrencySettingButton}
        onClick={onDelete}
        disabled={updateExternalSettingsIsLoading}
      >
        <IconClose width={16} height={16} />
      </button>
    </div>
  );
};

export default CurrencySettingItem;
